// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"CustomPagination_paginationWrapper__W7O1Y"};